function Shop() {
  return (
    <section className="generalContainer">
      <div className="generalBackground light-bg shopBackground">
        <div className="smooth-show">
          <h2 className="section-title">Shop</h2>
          <div className="shop-flex">
            <h3 style={{ color: 'black', fontSize: '2rem' }}>
              Under Construction
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Shop;
